import PharmacyClaimsEngine from "./PharmacyClaimsEngine";
import MedicalClaimsEngine from "./MedicalClaimsEngine";
import PharmacyEncounterClaimsEngine from "./PharmacyEncounterClaimsEngine";
import MedicalEncounterClaimsEngine from "./MedicalEncounterClaimsEngine";

const engines = {
  pharmacy: PharmacyClaimsEngine,
  medical: MedicalClaimsEngine,
  pharmacy_encounter: PharmacyEncounterClaimsEngine,
  medical_encounter: MedicalEncounterClaimsEngine,
};

const EngineHandler = (kind, options) => {
  if (!kind || !engines[kind]) {
    throw new Error(`Invalid or unsupported engine kind: ${kind}`);
  }

  if (!options || typeof options !== "object") {
    throw new Error("Invalid options provided");
  }

  return engines[kind](options);
};

export default EngineHandler;
